export { default, useDeviceContext } from './DeviceContext';
